// extracted by mini-css-extract-plugin
export default {"rep":"Highlight_rep__u37Jp","search":"Highlight_search__3d9zd","interpret":"Highlight_interpret__HydZ1"};